// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  useEmulators: false,
  firebaseConfig: {
    apiKey: "AIzaSyBYSIWFALrK8PH6wQMir3Bqc1Lx3LADR-I",
    authDomain: "the-dash-c7c98.firebaseapp.com",
    databaseURL: "https://the-dash-c7c98.firebaseio.com",
    projectId: "the-dash-c7c98",
    storageBucket: "the-dash-c7c98.appspot.com",
    messagingSenderId: "229745765707",
    appId: "1:229745765707:web:25565e49a9f678b9560cce",
    measurementId: "G-XMPZBJLNL5"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
